module.exports = "./img/7d48deef17d5c16b733e2e25ae7febdb.jpg";